export function isValidEmail(email: string) {
  return /^[a-z0-9_.\-+]+@[a-z0-9-.]+\.[a-z0-9]{2,}$/i.test(email);
}
